import { render, staticRenderFns } from "./SenhaAtendimento.vue?vue&type=template&id=ead95b14"
import script from "./SenhaAtendimento.vue?vue&type=script&lang=js"
export * from "./SenhaAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports